var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "header-bar" },
      [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "logo", on: { click: _vm.goHome } }, [
            _c(
              "div",
              {
                staticClass:
                  "[currentWidth > 1280 ? 'widthClass' : 'widthClassOther']",
              },
              [
                _vm.dynamicData.logo
                  ? _c("img", { attrs: { src: _vm.dynamicData.logo, alt: "" } })
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "title-height" }, [
              ["DF", "EC"].includes(_vm.$util.judgeOrigin()) &&
              _vm.$route.path !== "/home"
                ? _c("span", [_vm._v(_vm._s(_vm.dynamicData.productTitle))])
                : _vm._e(),
            ]),
          ]),
          _vm.products.length > 1 &&
          _vm.$route.path !== "/" &&
          _vm.$route.path !== "/home"
            ? _c(
                "span",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.changeShowProduct.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "check-product-btn" },
                    [_c("svg-icon", { attrs: { name: "changp" } })],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _c("password-modification"),
        _vm.$route.path !== "/home"
          ? _c("nav-bar", {
              key: _vm.langs,
              staticClass: "nav",
              attrs: {
                menu: _vm.nav,
                active: _vm.$route.path,
                "active-key": "path",
              },
              on: { change: _vm.changeNav },
            })
          : _vm._e(),
        _c("div", { staticClass: "right right-dis" }, [
          _vm.DFAuth && _vm.$route.path !== "/home"
            ? _c(
                "span",
                { staticClass: "help-icon", on: { click: _vm.moreMessage } },
                [
                  _vm.msgStatus
                    ? _c("svg-icon", { attrs: { name: "redmsg" } })
                    : _c("svg-icon", { attrs: { name: "msg" } }),
                ],
                1
              )
            : _vm._e(),
          _vm.DFAuth &&
          _vm.$route.path !== "/home" &&
          this.$util.getCurrentProductName() == "gt6"
            ? _c(
                "span",
                { staticClass: "help-icon", on: { click: _vm.helpClick } },
                [_c("svg-icon", { attrs: { name: "question" } })],
                1
              )
            : _vm._e(),
          !_vm.token
            ? _c("div", { staticClass: "login-btns" }, [
                _c(
                  "span",
                  { staticClass: "text-btn", on: { click: _vm.goLogin } },
                  [_vm._v(_vm._s(_vm.$t("components.header.login")))]
                ),
              ])
            : _c(
                "div",
                { staticClass: "login-btns" },
                [
                  _vm.$route.path === "/home"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "confirm-btn",
                          staticStyle: { "margin-right": "12px" },
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/dashboard")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("homes.enterSystem")))]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "head" },
                    [
                      _vm.langShow
                        ? _c("span", [
                            _c(
                              "span",
                              { class: _vm.isHome ? "color" : "white" },
                              [_vm._v(_vm._s(_vm.accountInfo.email))]
                            ),
                          ])
                        : _c("span", [
                            _vm.currentWidth >= 1440
                              ? _c(
                                  "span",
                                  { class: _vm.isHome ? "color" : "white" },
                                  [_vm._v(_vm._s(_vm.accountInfo.email))]
                                )
                              : _vm._e(),
                          ]),
                      _c(
                        "el-badge",
                        {
                          staticClass: "item",
                          attrs: {
                            hidden: !_vm.userInfo.updateStatus,
                            "is-dot": "",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "head-img",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goUserCenter.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "el-dropdown",
                                {
                                  staticClass: "dropdown",
                                  attrs: { size: "medium" },
                                  on: { command: _vm.handleCommand },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _vm.accountInfo.email
                                        ? _c(
                                            "span",
                                            { staticClass: "head-user" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.accountInfo.email
                                                    .slice(0, 2)
                                                    .toUpperCase()
                                                )
                                              ),
                                            ]
                                          )
                                        : _c("svg-icon", {
                                            attrs: { name: "head" },
                                          }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticStyle: {
                                        "margin-top": "22px",
                                        width: "128px",
                                        "text-align": "center",
                                        left: "1288px",
                                      },
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _vm.$util.judgeOrigin() == "DF" ||
                                      _vm.$util.judgeOrigin() == "TR"
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: "a" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "components.header.updateAnnouncement"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "b" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "components.header.accountCenter"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      ["DF", "EC"].includes(
                                        _vm.$util.judgeOrigin()
                                      )
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: "d" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "label label-important",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.changeLang()
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(_vm.lang))]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { command: "c", divided: "" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("components.header.LogOut")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }